export default __webpack_public_path__ + "fc6594bde0d010c32b655ee84a71d11f.png";